import React from "react";
import { Col, Row } from "react-bootstrap";

import { CreditCardIcon } from "components";
import { getFormattedExpirationDate } from "helpers";
import { amountToBeBilledCalculation } from "queries/terminalSolutions/getDefaultValuesPaymentMethods";
import { CreditCardTypes, BillToTypes, PaymentTypes } from "types";
import { float6Normalizer } from "validators";

import TextBlock from "../components/textBlock";

type paymentMethodProps = {
	paymentMethod?: { [key: string]: any };
	isPaymentMethodDeleted?: { [key: string]: any };
	billTo?: number;
	terminalList?: { [key: string]: any };
};

const BillingInformationView = ({
	paymentMethod,
	isPaymentMethodDeleted,
	billTo,
	terminalList,
}: paymentMethodProps) => {
	const billToDisplayName = BillToTypes.getDisplayName(billTo);
	const isBillToAurora = billTo === BillToTypes.aurora.value;

	const isPaymentMethodAch =
		paymentMethod?.payment_type === PaymentTypes.ach.name;

	const isPaymentMethodCreditCard =
		paymentMethod?.payment_type === PaymentTypes.creditCard.name;

	return (
		<>
			<Row>
				<Col xl={3}>
					<TextBlock
						label="Bill To"
						value={billToDisplayName}
						dataAutotest="billTo"
					/>
				</Col>
			</Row>
			<Row>
				<Col xl={3}>
					<TextBlock
						label="Amount To Be Billed"
						value={`$${
							float6Normalizer(
								amountToBeBilledCalculation(terminalList),
							) || "$0.00"
						}`}
						dataAutotest="amountToBeBilled"
					/>
				</Col>
			</Row>

			{!isBillToAurora && !isPaymentMethodDeleted && (
				<>
					<Row className="mt-3">
						<Col xl={3}>
							<TextBlock
								label="Payment Type"
								value={
									PaymentTypes.getByName(
										paymentMethod?.payment_type,
									)?.displayName
								}
								dataAutotest="paymentType"
							/>
						</Col>
					</Row>

					{isPaymentMethodAch && (
						<Row>
							<Col xl={3}>
								<TextBlock
									label="Routing Number (ABA)"
									value={paymentMethod?.ach?.routing_number}
									dataAutotest="routingNumber"
								/>
							</Col>
							<Col xl={3}>
								<TextBlock
									label="Account Number (DDA)"
									value={paymentMethod?.ach?.account_number}
									dataAutotest="accountNumber"
								/>
							</Col>
							<Col xl={3}>
								<TextBlock
									label="Bank Account Name"
									value={
										paymentMethod?.ach?.bank_account_name
									}
									dataAutotest="bankAccountName"
								/>
							</Col>
							<Col xl={3}>
								<TextBlock
									label="Bank"
									value={paymentMethod?.ach?.bank_name}
									dataAutotest="bank"
								/>
							</Col>
						</Row>
					)}
					{isPaymentMethodCreditCard && (
						<Row>
							<Col xl={3}>
								<TextBlock
									label="Cardholder Name"
									value={
										paymentMethod?.credit_card?.holder_name
									}
									dataAutotest="cardholderName"
								/>
							</Col>
							<Col xl={3} className="d-flex">
								<TextBlock
									label="Card Number"
									value={`**** ${paymentMethod?.credit_card?.last_digits}`}
									dataAutotest="cardNumber"
								/>
								<div className="ml-3">
									<CreditCardIcon
										name={
											CreditCardTypes.getByValue(
												paymentMethod?.credit_card
													?.network,
											)?.name
										}
									/>
								</div>
							</Col>
							<Col xl={3}>
								<TextBlock
									label="Expiration Date"
									value={`${getFormattedExpirationDate(
										paymentMethod?.credit_card
											?.expiration_month,
										paymentMethod?.credit_card
											?.expiration_year,
									)}`}
									dataAutotest="expirationDate"
								/>
							</Col>
							<Col xl={3}>
								<TextBlock
									label="CVV"
									value="***"
									dataAutotest="cvv"
								/>
							</Col>

							<Col xl={3}>
								<TextBlock
									label="Payee First Name"
									value={paymentMethod?.payee_first_name}
									dataAutotest="payeeFirstName"
								/>
							</Col>
							<Col xl={3}>
								<TextBlock
									label="Payee Last Name"
									value={paymentMethod?.payee_last_name}
									dataAutotest="payeeLastName"
								/>
							</Col>
						</Row>
					)}
				</>
			)}
		</>
	);
};

export default BillingInformationView;
